import {MedicineSchemaNew} from '@/modules/patients/schemas'

export const DrugFormOptions = {
  defaultValues: {
    activeSubstanceId: undefined,
    prescribedNameId: undefined,
    calculationMethod: undefined,
    regularDose: 0,
    precisionDecimals: 2,
    autIdem: false,
  } as MedicineSchemaNew,
}
